import { Injector } from '@angular/core'
import { IdentityService } from 'main/services/identity.service'
import { UserStorageService } from './sharedStorage.service'
import { BehaviorSubject } from 'rxjs'

export class BaseClipboardService<T> {
  protected items: T[] = []
  items$ = new BehaviorSubject<T[]>([])

  private userStorage: UserStorageService

  constructor (
    injector: Injector,
    private key: string,
  ) {
    this.userStorage = injector.get(UserStorageService)
    if (injector.get(IdentityService).loggedIn) {
      this.setItems(this.userStorage.get(this.key, []) ?? [])
      this.userStorage.observe(this.key).subscribe(v => {
        this.setItems(v, false)
      })
    }
  }

  clear (): void {
    this.setItems([])
  }

  save (): void {
    this.userStorage.querySet(this.key, this.items)
  }

  getItems (): T[] {
    return this.items
  }

  protected setItems (items: T[], save = true) {
    this.items = items
    this.items$.next(items)
    if (save) {
      this.save()
    }
  }

  addItem (item: T): void {
    this.setItems([...this.items, item])
  }

  removeItem (item: T): void {
    this.setItems(this.getItems().filter(x => x !== item))
  }
}
